import { TranslateService } from '@ngx-translate/core';

import { inject } from '@angular/core';

import { type ActionFactory } from '@shared/utils/entity-actions';

import type { User } from '../models';
import { UserPolicy } from '../user-policy';

export function injectUserActions() {
  const translate = inject(TranslateService);
  const policy = inject(UserPolicy);

  return {
    edit: (command) => ({
      icon: 'edit',
      label: translate.instant('common.actions.edit'),
      visible: (user) => policy.canEdit(user),
      command,
    }),
    resend: (command) => ({
      icon: 'mail-forward',
      label: translate.instant('entities.user.actions.resendInvite'),
      visible: (user) => policy.canResendInvite(user),
      command,
    }),
    activate: (command) => ({
      icon: 'user-check',
      label: translate.instant('entities.user.actions.activate'),
      visible: (user) => policy.canActivate(user),
      command,
    }),
    deactivate: (command) => ({
      icon: 'ban',
      color: 'danger',
      label: translate.instant('entities.user.actions.deactivate'),
      visible: (user) => policy.canDeactivate(user),
      command,
    }),
    delete: (command) => ({
      icon: 'trash',
      color: 'danger',
      label: translate.instant('common.actions.delete'),
      visible: (user) => policy.canDelete(user),
      command,
    }),
  } satisfies Record<string, ActionFactory<User>>;
}
